module.exports = __webpack_public_path__ + "media/application/images/ui/icon-footer-list-ecd4757c5dfe5bfddac02365c7c47237.png";